module.exports = __webpack_public_path__ + "fonts/RocGroteskWide-Bold.807f723.woff";